
import TestInstructionsStepOneComponent from "@/components/Shared/RegisterTest/TestInstructionsStepOne/TestInstructionsStepOneComponent";
export default TestInstructionsStepOneComponent;
